<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper">
          <h1 class="bani-title mb-0">Site Map</h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">Site Map</div>
        <div class="static-content-paragraph">
            <mat-grid-list cols="{{ isHandsetPortrait ? 1 : 2 }}" rowHeight="300px">
          <mat-grid-tile>
            <mat-list class="site-map-list">
              <!-- <div mat-subheader>Folders</div> -->
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToLink('dashboard')"
                  matListItemTitle
                >
                  Dashboard
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToLink('search')"
                  matListItemTitle
                >
                  Search
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToLink('significant-terms')"
                  matListItemTitle
                >
                  Significant Terms
                </div>
              </mat-list-item>
              <mat-list-item></mat-list-item>
              <mat-list-item></mat-list-item>
              <mat-list-item></mat-list-item>
            </mat-list>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-list class="site-map-list">
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('overview')"
                  matListItemTitle
                >
                  Overview
                </div>
              </mat-list-item>

              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('approach')"
                  matListItemTitle
                >
                  The Approach
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('glossary')"
                  matListItemTitle
                >
                  Glossary
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('team')"
                  matListItemTitle
                >
                  The Team
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('transcription-guidelines')"
                  matListItemTitle
                >
                  Transcription Guidelines
                </div>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>link</mat-icon>
                <div
                  class="sitemap-link cursor-pointer"
                  (click)="goToPage('bibliography')"
                  matListItemTitle
                >
                  Bibliography
                </div>
              </mat-list-item>
            </mat-list></mat-grid-tile
          >
        </mat-grid-list>

        </div>

        
        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
